/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TierName =
  | 'OPTED_OUT'
  | 'REWARDS_BASE'
  | 'REWARDS_OPTED_OUT'
  | 'SWEETPASS'
  | 'SWEETPASS_PLUS';

export type BagAvailablePointsQueryVariables = Exact<{ [key: string]: never }>;

export type BagAvailablePointsQuery = {
  readonly loyaltyProfile: {
    readonly customerId: string;
    readonly points: {
      readonly total: number;
      readonly available: number;
      readonly pending: number;
    } | null;
    readonly tier: {
      readonly __typename: 'Tier';
      readonly id: string;
      readonly nameV2: Types.TierName;
    } | null;
  } | null;
};

export const BagAvailablePointsDocument = gql`
  query BagAvailablePoints {
    loyaltyProfile {
      customerId
      points {
        total
        available
        pending
      }
      tier {
        id
        __typename
        nameV2
      }
    }
  }
`;

export function useBagAvailablePointsQuery(
  options?: Omit<Urql.UseQueryArgs<BagAvailablePointsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagAvailablePointsQuery, BagAvailablePointsQueryVariables>({
    query: BagAvailablePointsDocument,
    ...options,
  });
}
